import { __extends } from "tslib";
import * as React from 'react';
import IconEdit from 'wix-ui-icons-common/Edit';
import IconDelete from 'wix-ui-icons-common/Delete';
import IconV from 'wix-ui-icons-common/Check';
import IconX from 'wix-ui-icons-common/X';
import * as css from './ListItem.scss';
import { translate } from 'react-i18next';
import zIndex from '../../../constants/zIndex';
import { Tooltip, Popover, IconButton, Text, Input, Box, } from 'wix-style-react';
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            itemName: props.name,
            isUniqueItem: true,
        };
        return _this;
    }
    ListItem.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.name !== prevProps.name ||
            this.props.mode !== prevProps.mode) {
            this.setState({ itemName: this.props.name });
        }
    };
    ListItem.prototype.handleStartEdit = function () {
        var onStartEdit = this.props.onStartEdit;
        onStartEdit();
    };
    ListItem.prototype.onRenameApprove = function () {
        var itemName = this.state.itemName;
        this.props.onUpdate(itemName && itemName.trim());
    };
    ListItem.prototype.onRenameCancel = function () {
        this.props.onCancelEdit();
    };
    ListItem.prototype.handleDelete = function () {
        this.props.onDelete();
    };
    ListItem.prototype.handleOnItemNameChange = function (newName) {
        var trimmedNewName = newName && newName.trim();
        var trimmedPropName = this.props.name && this.props.name.trim();
        var isUniqueItem = trimmedNewName === trimmedPropName ||
            this.props.validateUniqueItem(trimmedNewName);
        this.setState({ itemName: newName, isUniqueItem: isUniqueItem });
    };
    ListItem.prototype.renderViewItem = function () {
        var _this = this;
        var _a = this.props, name = _a.name, icon = _a.icon, deleteTooltipText = _a.deleteTooltipText, renameTooltipText = _a.renameTooltipText;
        return (React.createElement("div", { className: css.itemView, "data-hook": "item-view" },
            React.createElement("span", { className: css.iconContainer }, icon),
            React.createElement(Text, { dataHook: "item-name", className: css.itemName, ellipsis: true, maxWidth: 360 }, name),
            React.createElement("div", { className: css.buttons },
                React.createElement(Tooltip, { content: renameTooltipText },
                    React.createElement("div", { className: css.leftButtonWrapper },
                        React.createElement(IconButton, { dataHook: "edit-btn", size: "small", skin: "inverted", priority: "primary", onClick: function () { return _this.handleStartEdit(); } },
                            React.createElement(IconEdit, { size: "18px" })))),
                React.createElement(Tooltip, { content: deleteTooltipText },
                    React.createElement("div", { className: css.rightButtonWrapper },
                        React.createElement(IconButton, { dataHook: "remove-btn", size: "small", skin: "inverted", priority: "primary", onClick: function () { return _this.handleDelete(); } },
                            React.createElement(IconDelete, { size: "18px" })))))));
    };
    ListItem.prototype.renderRenameItem = function () {
        var _this = this;
        var _a = this.state, itemName = _a.itemName, isUniqueItem = _a.isUniqueItem;
        var _b = this.props, hideEditBG = _b.hideEditBG, alreadyExistsText = _b.alreadyExistsText;
        return (React.createElement("div", { className: hideEditBG ? css.itemRenameNoBg : css.itemRename },
            React.createElement("div", { className: css.renameInput },
                React.createElement(Input, { dataHook: "edit-item-input", autoFocus: true, onChange: function (e) { return _this.handleOnItemNameChange(e.target.value); }, value: itemName })),
            React.createElement("div", { className: css.buttons },
                React.createElement("div", { className: css.leftButtonWrapper },
                    React.createElement(IconButton, { dataHook: "rename-x", priority: "secondary", onClick: function () { return _this.onRenameCancel(); } },
                        React.createElement(IconX, { size: "18px" }))),
                React.createElement(Popover, { shown: !!(!isUniqueItem && itemName), dataHook: "rename-tooltip", appendTo: "window", placement: "top", showArrow: true, maxWidth: 171, zIndex: zIndex.tooltip },
                    React.createElement(Popover.Element, null,
                        React.createElement("div", { className: css.rightButtonWrapper },
                            React.createElement(IconButton, { dataHook: "rename-v", priority: "primary", onClick: function () { return _this.onRenameApprove(); }, disabled: !isUniqueItem || !itemName },
                                React.createElement(IconV, { size: "18px" })))),
                    React.createElement(Popover.Content, null,
                        React.createElement(Box, { padding: "12px 24px" },
                            React.createElement(Text, { dataHook: "popover-text", size: "small", className: css.tooltipItemName }, alreadyExistsText(itemName))))))));
    };
    ListItem.prototype.render = function () {
        var _a = this.props, mode = _a.mode, dataHook = _a.dataHook;
        return (React.createElement("div", { "data-hook": dataHook },
            mode === 'view' && this.renderViewItem(),
            mode === 'edit' && this.renderRenameItem()));
    };
    return ListItem;
}(React.PureComponent));
export default translate()(ListItem);
//# sourceMappingURL=ListItem.js.map